import React from 'react';
import { formatGeoCitationShare, formatGeoCitationUrl } from '../utils/geoPresentation';
import GeoMetricTitle from './GeoMetricTitle';
import GeoTableHeaderLabel from './GeoTableHeaderLabel';

export default function GeoCitationsTable({
  rows = [],
  totalCitations = 0,
  uniquePages = 0,
  loading = false,
}) {
  return (
    <div className="report-card volume-chart-panel geo-insights-table-card geo-insights-citations-card">
      <div className="chart-panel__header">
        <GeoMetricTitle metricKey="citations">Top Citations</GeoMetricTitle>
      </div>
      <div className="geo-insights-table-wrap">
        <table className="sec-filing-insights-data-table geo-insights-data-table geo-citations-table">
          <thead>
            <tr>
              <th className="geo-citations-table__col-rank">Rank</th>
              <th className="geo-citations-table__col-url">URL</th>
              <th className="geo-citations-table__col-share">
                <GeoTableHeaderLabel metricKey="citation_share">Citation share</GeoTableHeaderLabel>
              </th>
              <th className="geo-citations-table__col-count"># of citations</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4}>Loading…</td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={4}>
                  {totalCitations === 0
                    ? 'No URLs were cited in this range'
                    : 'No citations to display'}
                </td>
              </tr>
            ) : (
              rows.map((row, index) => (
                <tr key={row.url} style={{ '--table-row-delay': index }}>
                  <td>{row.rank}</td>
                  <td>
                    <a
                      href={row.url}
                      className="geo-citations-table__url"
                      target="_blank"
                      rel="noopener noreferrer"
                      title={row.url}
                    >
                      {row.faviconUrl ? (
                        <img
                          src={row.faviconUrl}
                          alt=""
                          className="geo-citations-table__favicon"
                          width={16}
                          height={16}
                          loading="lazy"
                        />
                      ) : null}
                      <span className="geo-citations-table__url-text">{formatGeoCitationUrl(row.url)}</span>
                    </a>
                  </td>
                  <td>{formatGeoCitationShare(row.citationShare)}</td>
                  <td>{row.citationCount}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {totalCitations > 0 ? (
        <div className="geo-citations-card__footer">
          <span className="geo-citations-card__footer-note">
            {uniquePages > rows.length
              ? `Top ${rows.length} of ${uniquePages} pages · ${totalCitations} total citations`
              : `${uniquePages || rows.length} page${(uniquePages || rows.length) === 1 ? '' : 's'} · ${totalCitations} total citations`}
          </span>
        </div>
      ) : null}
    </div>
  );
}
